export function createActionFormRequestCoordinator() {
  let activeRequest = null;
  let sequence = 0;

  function settle(request, value) {
    if (!request || request.settled) return false;
    request.settled = true;
    if (activeRequest === request) activeRequest = null;
    request.resolve(value);
    return true;
  }

  return Object.freeze({
    replace(resolve) {
      if (typeof resolve !== 'function') {
        throw new TypeError('Action form request resolver must be a function');
      }
      if (activeRequest) settle(activeRequest, null);
      const request = {
        id: ++sequence,
        resolve,
        settled: false,
      };
      activeRequest = request;
      return request.id;
    },

    isActive(requestId) {
      return Boolean(activeRequest && activeRequest.id === requestId && !activeRequest.settled);
    },

    settle(requestId, value) {
      if (!activeRequest || activeRequest.id !== requestId) return false;
      return settle(activeRequest, value);
    },

    cancel() {
      return activeRequest ? settle(activeRequest, null) : false;
    },
  });
}
